export const formatTaxNumberInput = (value: string): string => {
  const digits = String(value ?? "")
    .replace(/\D+/g, "")
    .slice(0, 11);

  const part1 = digits.slice(0, 8);
  const part2 = digits.slice(8, 9);
  const part3 = digits.slice(9, 11);

  if (digits.length <= 8) {
    return part1;
  }

  if (digits.length <= 9) {
    return `${part1}-${part2}`;
  }

  return `${part1}-${part2}-${part3}`;
};

export const isFormattedTaxNumberValid = (value: string): boolean => {
  return /^\d{8}-\d-\d{2}$/.test(String(value ?? "").trim());
};
